import { building } from "@/content/copy";
import { Eyebrow, Reveal } from "./primitives";

export const Building = () => (
  <section id="next" data-testid="whats-next-section" className="ph-section scroll-mt-20">
    <div className="ph-container">
      <div className="grid lg:grid-cols-12 gap-10">
        <Reveal className="lg:col-span-6">
          <Eyebrow>{building.eyebrow}</Eyebrow>
          <h2 data-testid="whats-next-heading" className="ph-h2 mt-6">{building.heading}</h2>
        </Reveal>
        <Reveal delay={0.1} className="lg:col-span-5 lg:col-start-8 lg:pt-14">
          <p className="ph-lead">{building.intro}</p>
        </Reveal>
      </div>
      <ul className="mt-16 sm:mt-24 grid md:grid-cols-2 border-t ph-rule" aria-label="Planned features">
        {building.items.map((item, i) => (
          <Reveal as="li" key={item} delay={0.06 * i} className={`ph-plan ${i % 2 === 0 ? "md:border-r md:pr-10" : "md:pl-10"}`}>
            <div data-testid={`roadmap-item-${i + 1}`} className="py-9 sm:py-12">
              <div className="flex items-center justify-between">
                <span className="ph-plan-num" aria-hidden="true">0{i + 1}</span>
                <span className="ph-tag" data-testid={`roadmap-tag-${i + 1}`}>
                  <span className="ph-tag-dot" aria-hidden="true" />{building.tag}
                </span>
              </div>
              <h3 className="ph-plan-title mt-6">{item}</h3>
            </div>
          </Reveal>
        ))}
      </ul>
      <Reveal className="mt-12 sm:mt-16 max-w-2xl">
        <p data-testid="roadmap-secondary-note" className="ph-note">
          <span className="ph-note-mark" aria-hidden="true">*</span>{building.note}
        </p>
      </Reveal>
    </div>
  </section>
);
